import { render, staticRenderFns } from "./licitaciones.vue?vue&type=template&id=182f7730"
import script from "./licitaciones.vue?vue&type=script&lang=js"
export * from "./licitaciones.vue?vue&type=script&lang=js"
import style0 from "./licitaciones.vue?vue&type=style&index=0&id=182f7730&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports